module.exports = __webpack_public_path__ + "img/unicode_code_point.826cf683.png";